export enum Metals {
  PLATINUM = 'platinum',
  PALLADIUM = 'palladium',
  RHODIUM = 'rhodium',
}
